module.exports = __webpack_public_path__ + "static/media/editor-icon.0f7e5271.svg";